<div class="cont-carousel-virtual"
     *ngIf="arrayProducts && !shortcuts"
     [class.sustitutes]="isSustitutes"
     [class.video]="videoOnly"
     [class.vto-filter]="isVTO"
     [style]="customStyle"
     [class.cont-carousel-virtual__group]="isGroup"
     [class.cont-carousel-virtual--home]="isHome"
     [ngClass]="{'content-offers-flash':isFlashOffer, 'cont-carousel-virtual-dermo': isDermo}"
     >
  <virtual-scroller
    #scroll
    [items]="transformedProducts"
    class="virtual-scroll"
    [horizontal]="true"
    (vsEnd)="eventScroll($event)"
    [ssrChildHeight]="250"
    [ssrChildWidth]="300"
    [ssrViewportHeight]="1080"
    [ssrViewportWidth]="1920"
    [bufferAmount]="isMobile ? 5 : null"
    [scrollThrottlingTime]="isMobile ? 50 : null"
    [checkResizeInterval]="isMobile ? 500 : null"
    [enableUnequalChildrenSizes]="isMobile ? true : null"
    [modifyOverflowStyleOfParentScroll]="isMobile ? true : null"
    *ngIf="transformedProducts.length > 0"
  >
    <ng-container *ngFor="let item of scroll.viewPortItems; let i = index">
      <ng-container [ngSwitch]="item.type">
        <ng-container *ngSwitchCase="'full'">
          <div class="column-full">
            <ng-container *ngTemplateOutlet="productCard; context: {
              $implicit: item.product,
              columnHalf: item.product.isHalf,
              class: item.product.class
            }"></ng-container>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'half-group'">
          <div class="column-half-group">
            <div *ngFor="let product of item.products" class="column-half">
              <ng-container *ngTemplateOutlet="productCard; context: {
                $implicit: product,
                columnHalf: product.isHalf,
                class: product.class
              }"></ng-container>
            </div>
          </div>
        </ng-container>

        <ng-container *ngSwitchDefault>
          <ng-container *ngIf="videoOnly">
            <div class="cont-video-publicity" (click)="goTo(item)">
              <div class="cont-img">
                <img class="img" [src]="item.thumbnail" [alt]="item.title" loading="lazy">
                <app-icons class="icon-arrow" [type]="'arrow-fill'" [custom]="'rigth lg'"></app-icons>
              </div>
              <p class="title-video">{{ item.title | titlecase }}</p>
            </div>
          </ng-container>

          <ng-container *ngIf="!videoOnly">
            <ng-container *ngIf="!imageContent">
              <ng-container *ngTemplateOutlet="productCard; context: {
                $implicit: item,
                isFirst: i === 0
              }"></ng-container>
            </ng-container>

            <ng-container *ngIf="imageContent">
              <img class="image-slider-item" [src]="item.mediaImageUrl" [alt]="item.description + ' ' + item.detailDescription" loading="lazy">
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </virtual-scroller>

  <ng-template #productCard let-product let-columnHalf="columnHalf" let-class="class" let-isFirst="isFirst">
    <app-new-product-card
      *ngIf="!videoOnly"
      [arrayProducts]="arrayProducts"
      [componentType]="componentType"
      [isSustitutes]="isSustitutes"
      [idPrefix]="idPrefix"
      [product]="product"
      [isMini]="miniCard"
      [isHome]="isHome"
      [isVTO]="isVTO"
      [isFlashOffer]="isFlashOffer"
      [dataLoaded]="dataLoaded"
      [lazyLoaded]="true"
      [isCarousel]="true"
      [groupType]="groupType"
      [columnHalf]="columnHalf"
      [ngClass]="class"
      [isFirst]="isFirst"
      [discountsLoaded]="discountsLoaded"
    ></app-new-product-card>
  </ng-template>

  <ng-container *ngTemplateOutlet="arrow"></ng-container>
</div>


<div class="cont-carousel-virtual-shortcuts" *ngIf="shortcuts">
  <virtual-scroller #scroll [items]="shortcuts"
                    class="virutal-scroll"
                    [horizontal]="true" (vsEnd)="eventScroll($event)"
                    *ngIf="shortcuts?.length > 0">
    <div *ngFor="let shortcut of scroll.viewPortItems" class="slide">
      <a
        (click)="handleRedirect(shortcut.redirectURL)"
        class="link"
      >
        <figure class="figure">
          <div class="container-image">
            <img *ngIf="!performanceActive" class="image" [src]="shortcut.imageURL" [alt]="shortcut.description">
          </div>
          <div class="container-title">
            <figcaption class="caption">{{shortcut.description}}</figcaption>
          </div>
        </figure>
      </a>
    </div>
  </virtual-scroller>
  <ng-container *ngTemplateOutlet="arrow"></ng-container>
</div>

<ng-template #arrow>
  <div class="cont-carousel-virtual__arrow"
  [class.cont-carousel-virtual__arrow--shortcuts]="shortcuts"
  [class.small]="smallArrow"
  [class.cont-carousel-virtual__dermo--arrow]="isDermo"
  [class.cont-carousel-virtual__group--arrow]="isGroup"
  (click)="next($event)"
  [class.disabled]="arrows.right.disabled"
  *ngIf="arrows.right.show">
  <app-icons [type]="'arrow-simple'" [custom]="smallArrow ? 'sm' : 'md'"></app-icons>
  </div>
  <div class="cont-carousel-virtual__arrow arrow-back"
  [class.cont-carousel-virtual__arrow--shortcuts]="shortcuts"
  [class.small]="smallArrow"
  [class.cont-carousel-virtual__dermo--arrow]="isDermo"
  [class.cont-carousel-virtual__group--arrow]="isGroup"
  (click)="back($event)"
  [class.disabled]="arrows.left.disabled"
  *ngIf="arrows.left.show">
  <app-icons [type]="'arrow-simple'" [custom]="(smallArrow ? 'sm' : 'md') + ' left'"></app-icons>
  </div>
</ng-template>
